import React from 'react';

import {
  Dialog, DialogContent, DialogProps, IconButton,
} from '@mui/material';
import HeartWordsSelectionDialog from 'src/components/dialogs/CreatePresstoDialog/HeartWordsSelectionDialog';
import { HeartWordsSelectionDialogProps } from 'src/components/dialogs/CreatePresstoDialog/types';
import { DialogCloseImg } from 'src/assets/icons';

export default function HeartWordsDialog(
  props: (DialogProps & HeartWordsSelectionDialogProps & {
    onClose: (...args: any[]) => void;
  }),
) {
  const {
    open, onAdd, initialHeartWords, onClose,
  } = props;

  return (
    <Dialog
      open={open}
      PaperProps={{ elevation: 5 }}
      onClose={onClose}
      sx={{
        '.close-button': {
          position: 'absolute',
          top: '.25rem',
          right: '.25rem',
        },
      }}
    >
      <DialogContent>
        <HeartWordsSelectionDialog
          onAdd={onAdd}
          initialHeartWords={initialHeartWords}
        />
      </DialogContent>

      <IconButton className="close-button" onClick={onClose}>
        <img src={DialogCloseImg} alt="close dialog" />
      </IconButton>
    </Dialog>
  );
}
